import { hexToRGBA } from '@famly/stat_ts-utils_hex-to-rgba';
/**
 * Resolves a ThemeValue to a concrete string using the current theme.
 *
 * @param value - Static string, theme-derived function, or undefined
 * @param theme - The current whitelabel theme
 * @returns Resolved string value, or undefined if value is undefined
 */
export const resolveThemeValue = (value, theme) => {
    if (value === undefined) {
        return undefined;
    }
    return typeof value === 'function' ? value(theme) : value;
};
const withChromeOpacity = (opacity) => theme => hexToRGBA(theme.chromeColor, opacity);
/**
 * Per-whitelabel signin-app configuration overrides.
 * Whitelabels absent from this map use all defaults from build-config.ts.
 */
export const signinAppConfigs = {
    famly: {
        // Famly uses a semi-transparent text color for empty pills instead of invertedText
        pinPillEmptyColor: theme => hexToRGBA(theme.text, 0.5),
    },
    espira: {
        primaryBackgroundColor: '#669600',
        secondaryBackgroundColor: '#96C120',
        pinButtonColor: 'n500',
        loginPagesFontColor: 'n500',
        pinShadowColor: theme => theme.text,
        pinPillEmptyColor: '#8BB320',
        p500: '#96C120',
        p400: '#669600',
        p300: '#4D7300',
        p200: '#F0F9D8',
    },
    kido: {
        secondaryBackgroundColor: withChromeOpacity(0.8),
    },
    brighthorizons: {
        primaryBackgroundColor: '#1F3E4E',
        secondaryBackgroundColor: '#004A61',
    },
    kindred: {
        secondaryBackgroundColor: withChromeOpacity(0.8),
    },
    grandiruk: {
        secondaryBackgroundColor: withChromeOpacity(0.8),
    },
    nuffieldhealth: {
        p500: '#003D00',
        p400: '#00A200',
        p300: '#00B200',
        p200: '#F5FFF5',
    },
    nfamilyclub: {
        secondaryBackgroundColor: withChromeOpacity(0.8),
    },
    nfamilyschool: {
        secondaryBackgroundColor: withChromeOpacity(0.8),
    },
    kinderzimmeruk: {
        secondaryBackgroundColor: withChromeOpacity(0.8),
    },
    cpctreehouse: {
        secondaryBackgroundColor: withChromeOpacity(0.8),
    },
    cpcorchards: {
        secondaryBackgroundColor: withChromeOpacity(0.8),
    },
    busybees: {
        secondaryBackgroundColor: withChromeOpacity(0.8),
        p500: theme => theme.chromeColor,
    },
    bbmontessori: {
        secondaryBackgroundColor: withChromeOpacity(0.8),
        p500: theme => theme.chromeColor,
    },
    bbodyssey: {
        secondaryBackgroundColor: withChromeOpacity(0.8),
        p500: theme => theme.chromeColor,
    },
    twizzletops: {
        secondaryBackgroundColor: withChromeOpacity(0.8),
    },
    childbase: {
        secondaryBackgroundColor: withChromeOpacity(0.8),
        p500: theme => theme.chromeColor,
    },
    seymourhouse: {
        secondaryBackgroundColor: withChromeOpacity(0.8),
        circleAndDotColor: theme => theme.chromeColor,
        p500: theme => theme.chromeColor,
    },
    whitelabeltest: {
        secondaryBackgroundColor: withChromeOpacity(0.8),
    },
};
